import React, { useEffect, useState, useRef } from 'react';
import "./styleAddProject.css"
import { useDispatch, useSelector } from 'react-redux';
import profile from "../../../../assets/images/profile.png";
import { setAddProject, setProject, setProjectList, setUpdateProjectFlag, setPrjUpdListFlag} from '../../../../erpStore/actions';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Calendar } from "primereact/calendar";
import moment from 'moment';

function UpdateProject() {

    const dispatch = useDispatch();
    const apiUrl = useSelector((state) => state.data.apiUrl)
    const stringHeaders = window.localStorage.getItem('myHeaders')
    const storedHeaders = JSON.parse(stringHeaders);
    const selfInfo = useSelector((state) => state.data.selfData)
    const [error, setError] = useState(false);


    const [projectTitle, setProjectTitle] = useState('')

    const [selectedDeprtList, setSelectedDerptList] = useState([])
    const dDepartments = useSelector((state) => state.data.tagList)
    const [departmentList, setDepList] = useState(dDepartments);
    const [deprtListFlag, setDeprtListFlag] = useState(false);
    const deprtListRef = useRef(null)

    const [managerList, setManagerList] = useState();
    const [manager, setManager] = useState();
    const [manegarListFlag, setMangerListFlag] = useState(false);
    const [selectedManager, setSelectedManager] = useState(null);
    
    const manegerLstRef = useRef(null);
    
    const [startDateFlag ,setStartDateFlag] = useState(false);
    const [prjStartDate ,setPrjStartDate] = useState(null);
    const stratDateRef = useRef(null);

    const [endDateFlag ,setEndDateFlag] = useState(false);
    const [prjEndDate ,setPrjEndDate] = useState(null);
    const endDateRef = useRef(null);

    const dAssignees = useSelector((state) => state.data.assgineeList)
    const [assigneeList, setAssigneeList] = useState(dAssignees);
    const [assigneeListFalg, setAssigneeListFalg] = useState(false)
    const [selectedAssigneeList, setSelectedAssigneeList] = useState([])
    const assigneeListRef = useRef(null) 
    
    const dPriorities = useSelector((state) => state.data.priorityList)
    const [priorityList, setPriorityList] = useState(dPriorities)
    const [selectedPriority, setSelectedPriority] = useState()
    const [priorityListFlag, setPriorityListFlag] = useState(false)
    const priorityListRef = useRef(null)

    const project = useSelector((state) => state.data.projectToUpadte)
    const [projectName, setProjectName] = useState(project.projectName)
    const [projectManager, setProjectManager] = useState(project.projectManager)
    const [projectStartDate, setProjectStartDate] = useState(project.projectStartDate)
    const [projectEndDate, setProjectEndDate] = useState(project.projectEndDate)
    const [projectDepartments, setProjectDepartments] = useState(project.projectDepartments)
    const [projectEmployees, setProjectEmployees] = useState(project.projectEmployees)
    const [projectPriority, setProjectPriority] = useState(project.projectPriority)

    const [projectUpdatePara, setProjectUpdatePara] = useState({'projectId' : project.projectId})

    useEffect(() => {
       
        axios.get(`${apiUrl}project/get/managers`, {
            headers: storedHeaders
        })
            .then((response) => {
                if(response.request.status === 200){
                    setManagerList(response.data)
                }
            })

    }, [])


    const handleSubmit = async () => {

        if(Object.keys(projectUpdatePara).length === 1){
            toast.error("all ready updated",{autoClose: 2000} )
            dispatch(setUpdateProjectFlag(false));
            return
        }

        if(projectDepartments.length === 0){
            toast.error("Please select department first",{autoClose: 2000})
            return
        }

        if(projectName === ''){
            toast.error('Please add the project name', {autoClose : 2000})
            return
        }

        axios.put(`${apiUrl}project/update `, projectUpdatePara, {headers: storedHeaders})
        .then(response => {
            if(response.request.status === 200){
                toast.success("project updated successfully", {autoClose: 2000})
                dispatch(setUpdateProjectFlag(false));
                dispatch(setPrjUpdListFlag(true))
            }
        })
        .catch(error => {
            switch (error.response.status){
                case 400:
                    toast.error("Bad Request", {autoClose: 2000})
                    break;
                
                case 404:
                    toast.error("Not Found", {autoClose: 2000})
                    break;

                case 422:
                    toast.error("Error Occured", {autoClose: 2000})
                    break;
                    
                default:
                    break;
            }
        })
    }

    useEffect(() => {
        function handleOutsideClick(event) {
          if (manegerLstRef && manegerLstRef.current && !manegerLstRef.current.contains(event.target)) {
            setMangerListFlag(false)
          }else if (stratDateRef && stratDateRef.current && !stratDateRef.current.contains(event.target)) {
            setStartDateFlag(false)
          }else if (endDateRef && endDateRef.current && !endDateRef.current.contains(event.target)) {
            setEndDateFlag(false)
          }else if (deprtListRef && deprtListRef.current && !deprtListRef.current.contains(event.target)) {
            setDeprtListFlag(false)
          }else if (assigneeListRef && assigneeListRef.current && !assigneeListRef.current.contains(event.target)) {
            setAssigneeListFalg(false)
          }else if (priorityListRef && priorityListRef.current && !priorityListRef.current.contains(event.target)) {
            setPriorityListFlag(false)
          } 
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
          document.removeEventListener("mousedown", handleOutsideClick)
        }
      }, [])
      
      function checkDepartmentsMatched() {
        
        const taskDepartmentIds = project.projectDepartments.map(department => department.departmentId);
      
        // Copying the departments array
        const tempDepartments = [...projectDepartments];
      
        if (taskDepartmentIds.length === tempDepartments.length && !taskDepartmentIds.every(departmentId => tempDepartments.some(dep => dep.departmentId === departmentId))) {
          let departmentsIdArr = tempDepartments.map(tag => tag.departmentId);
          setProjectUpdatePara(prevState => ({
            ...prevState,
            ['projectDepartments']: departmentsIdArr
          }));
          projectUpdatePara['projectDepartments'] = departmentsIdArr
          setProjectUpdatePara(projectUpdatePara)
          
        } else if (taskDepartmentIds.length !== tempDepartments.length || tempDepartments.length === 0) {
          let departmentsIdArr = tempDepartments.map(tag => tag.departmentId);
          setProjectUpdatePara(prevState => ({
            ...prevState,
            ['projectDepartments']: departmentsIdArr
          }));

          projectUpdatePara['projectDepartments'] = departmentsIdArr
          setProjectUpdatePara(projectUpdatePara)
        } else {
          delete projectUpdatePara['projectDepartments'];
          setProjectUpdatePara(prevState => ({ ...prevState }));
        }
      }

    
      useEffect(() => {
        if (projectDepartments.length > 0) {
            const departmentIdArray = projectDepartments.map(department => department.departmentId);
    
            axios
                .post(`${apiUrl}project/get/assignee`, { department: departmentIdArray }, { headers: storedHeaders })
                .then(response => {
                    if (response.status === 200) {
                        const filteredEmployees = response.data.filter(obj => 
                            !projectEmployees.some(employee => employee?.empId === obj?.empId)
                        );
                        
                        console.log("Filtered Employees:", filteredEmployees);
                        setAssigneeList(filteredEmployees);
                    }
                })
                .catch(error => {
                    console.error("Error fetching assignees:", error);
                });
        } else {
            setProjectEmployees([]);
        }
    }, [projectDepartments]); // Include all dependencies
    
    

      const handleProjectName = (e) => {
        setProjectName(e.target.value)

        if(e.target.value !== project.projectName && e.target.value !== ''){
            setProjectUpdatePara(prevState => ({
                ...prevState,
                ['projectName']: e.target.value
              }));
        }else{
            setProjectUpdatePara(prevState => {
                const newState = { ...prevState };
                delete newState['projectName'];
                return newState;
              });
        }   
      }

    function checkProjectEmployees(){
        const taskEmployeeIds = project.projectEmployees.map(employee => employee.empId);
      
        // Copying the departments array
        const tempEmployees = [...projectEmployees];
      
        if(taskEmployeeIds.length === 0 && tempEmployees.length === 0){
            delete projectUpdatePara['projectEmployees'];
            setProjectUpdatePara(prevState => ({ ...prevState }));
        }else if (taskEmployeeIds.length === tempEmployees.length && !taskEmployeeIds.every(demployeeId => tempEmployees.some(employee => employee.empId === demployeeId))) {
          let employeeIdArr = tempEmployees.map(employee => employee.empId);
          setProjectUpdatePara(prevState => ({
            ...prevState,
            ['projectEmployees']: employeeIdArr
          }));
          projectUpdatePara['projectEmployees'] = employeeIdArr
          setProjectUpdatePara(projectUpdatePara)
        
        } else if (taskEmployeeIds.length !== tempEmployees.length || tempEmployees.length === 0) {
          let employeeIdArr = tempEmployees.map(employee => employee.empId);
          setProjectUpdatePara(prevState => ({
            ...prevState,
            ['projectEmployees']: employeeIdArr
          }));

          projectUpdatePara['projectEmployees'] = employeeIdArr
          setProjectUpdatePara(projectUpdatePara)
        } else {
          delete projectUpdatePara['projectEmployees'];
          setProjectUpdatePara(prevState => ({ ...prevState }));
        }
    }

      useEffect(() => {
        checkProjectEmployees()
      }, [projectEmployees])

  return (
    <div className="ProjectFrom active">
            <div className='projectForm-container active'>
                <div className='dash-header'>
                    <div className='dash-header-container'>
                        <div className='dashHead-left-content'>
                            {/* <svg  onClick={() => {
                                dispatch(setUpdateProjectFlag(false));
                            }} width="22" height="22" style={{ marginLeft: '15px', cursor: 'pointer'}} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
                            </svg> */}
                        </div>
                        <div className='dashHead-right-content active'>
                            <img className='profileImg' src={selfInfo.empImg ? selfInfo.empImg : profile} alt='/' />
                            <p className='profileName'>{selfInfo.empFullName}</p>
                 
                        </div>
                    </div>
                </div>
                <div className='pHeader'>Update Project</div>
                <div className='project-form'>
                    <div className='project-info-slot1'>
                        <input className='projectName' value={projectName} style={{borderBottom: projectName === '' ? '0.5px solid red' : '0.5px solid grey' }} onChange={(e) => {handleProjectName(e)}} type='text' placeholder='*Enter Project Name' />
                        {projectName === '' ? <p style={{fontSize: '12px', color: 'red'}}>Please Enter Project Name</p> : null}
                    </div>
                    <div className='project-info-slot1'>
                        <label>*Project Manager</label>

                        <div className='selectMangerHld'>
                            <div className='selectedMnginfo' onClick={() => {setMangerListFlag(true)}}>
                                <p style={{fontSize: '16px', color: 'rgba(38, 50, 56, 1)', fontFamily: 'Roboto'}}>{projectManager !==null ? projectManager?.empFullName: '-'}</p>
                                { projectManager !== null ? 
                                    <p style={{color: 'rgba(38, 50, 56, 0.8)', fontFamily: 'Roboto', marginLeft: '2px', marginTop: '3px', fontSize: '12px'}}>{`(${projectManager.role[0].roleName
                                    })`}</p>
                                    : null
                                }
                                
                                {error && projectManager === null ? <p style={{fontSize: '12px', color: 'red', position: 'absolute', left: '0px', top: '31px'}}>Please select the maneger first</p> : null}

                            </div>

                            { manegarListFlag && 
                                <div className='managerListDiv' ref={manegerLstRef}>
                                    <div className='mangerListScroller'>
                                        { managerList && managerList.length > 0 && managerList.map((managerObj) => (
                                            <div className='selectedManagerHold' style={{cursor: 'pointer'}} onClick={() => {
                                                var tempProjectManegar = managerObj  
                                                setProjectManager(managerObj)
                                                    if(project.projectManager.empId.toString() !== tempProjectManegar.empId.toString()){
                                                        setProjectUpdatePara(prevState => ({
                                                        ...prevState,
                                                        ['projectManager']: tempProjectManegar.empId
                                                    }));
                                                    projectUpdatePara['projectManager'] = tempProjectManegar.empId
                                                    setProjectUpdatePara(projectUpdatePara)
                                                    }else{
                                                    delete projectUpdatePara['projectManager']
                                                    setProjectUpdatePara(projectUpdatePara)
                                                    }
                                                setMangerListFlag(false)
                                            }}>
                                                <p style={{fontSize: '16px', color: 'rgba(38, 50, 56, 1)', fontFamily: 'Roboto'}}>{managerObj.empFullName}</p>
                                                <p style={{color: 'rgba(38, 50, 56, 0.8)', fontSize: '12px', fontFamily: 'Roboto', marginLeft: '2px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end',height: '100%'}}>{`(${managerObj.role[0].roleName})`}</p>
                                            </div>
                                        ))                                            
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className='project-info-slot2'>
                        <div className='slot-part-add-project'>
                            <label>*Start Date</label>
                            {/* <input type='date' value={projectObj.projectStartDate} onChange={handleStartDate}></input> */}
                            <div className='prjStrDateHold'>

                                <div className='prjSatrtDate' onClick={() => {setStartDateFlag(true)}}>
                                    <p className='prjStrDtePara'>{projectStartDate}</p>

                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74656 1.93343C2.12713 2.01674 1.77036 2.17297 1.51 2.43355C1.24942 2.69391 1.09292 3.05096 1.00961 3.67038C0.92451 4.30309 0.923529 5.13714 0.923529 6.31108V7.54245C0.923529 8.71638 0.92451 9.55044 1.00961 10.1831C1.09292 10.8026 1.24914 11.1593 1.50973 11.4197C1.77009 11.6803 2.12713 11.8368 2.74656 11.9201C3.37926 12.0052 4.21332 12.0062 5.38725 12.0062H7.84999C9.02393 12.0062 9.85798 12.0052 10.4907 11.9201C11.1101 11.8368 11.4669 11.6806 11.7272 11.42C11.9878 11.1596 12.1443 10.8026 12.2276 10.1831C12.3127 9.55044 12.3137 8.71638 12.3137 7.54245V6.31108C12.3137 5.13714 12.3127 4.30309 12.2276 3.67038C12.1443 3.05096 11.9881 2.69419 11.7275 2.43383C11.4672 2.17325 11.1101 2.01674 10.4907 1.93343C9.85798 1.84834 9.02393 1.84736 7.84999 1.84736H5.38725C4.21332 1.84736 3.37926 1.84834 2.74656 1.93343ZM5.3525 0.923828H7.88474C9.01614 0.923819 9.91238 0.923811 10.6138 1.01815C11.3355 1.11521 11.9197 1.31972 12.3803 1.78052C12.8413 2.24113 13.0458 2.82544 13.1429 3.54728C13.2373 4.24868 13.2372 5.14492 13.2372 6.27632V7.57721C13.2372 8.7086 13.2373 9.60484 13.1429 10.3062C13.0458 11.028 12.8413 11.6123 12.3804 12.0729C11.9198 12.5338 11.3356 12.7383 10.6138 12.8354C9.91238 12.9297 9.01614 12.9297 7.88475 12.9297H5.35249C4.2211 12.9297 3.32486 12.9297 2.62345 12.8354C1.90161 12.7383 1.3173 12.5337 0.856692 12.0727C0.395887 11.6122 0.191385 11.0279 0.094319 10.3062C-1.73397e-05 9.60484 -9.56362e-06 8.7086 1.97977e-07 7.57719V6.27633C-9.56362e-06 5.14493 -1.73397e-05 4.24869 0.094319 3.54728C0.191395 2.82551 0.395928 2.24125 0.856831 1.78066C1.31742 1.31976 1.90168 1.11522 2.62345 1.01815C3.32486 0.923811 4.2211 0.923819 5.3525 0.923828Z" fill="#263238"/>
                                        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M3.54094 0C3.79597 0 4.00271 0.206739 4.00271 0.461764V1.38529C4.00271 1.64032 3.79597 1.84706 3.54094 1.84706C3.28592 1.84706 3.07918 1.64032 3.07918 1.38529V0.461764C3.07918 0.206739 3.28592 0 3.54094 0ZM9.6978 0C9.95282 0 10.1596 0.206739 10.1596 0.461764V1.38529C10.1596 1.64032 9.95282 1.84706 9.6978 1.84706C9.44277 1.84706 9.23603 1.64032 9.23603 1.38529V0.461764C9.23603 0.206739 9.44277 0 9.6978 0ZM0.308594 4.46372C0.308594 4.20869 0.515333 4.00196 0.770358 4.00196H12.4684C12.7234 4.00196 12.9301 4.20869 12.9301 4.46372C12.9301 4.71875 12.7234 4.92548 12.4684 4.92548H0.770358C0.515333 4.92548 0.308594 4.71875 0.308594 4.46372Z" fill="#263238"/>
                                        <path d="M10.314 9.38898C10.314 9.55227 10.2491 9.70887 10.1337 9.82433C10.0182 9.93979 9.86161 10.0047 9.69832 10.0047C9.53503 10.0047 9.37843 9.93979 9.26297 9.82433C9.1475 9.70887 9.08264 9.55227 9.08264 9.38898C9.08264 9.22569 9.1475 9.06908 9.26297 8.95362C9.37843 8.83816 9.53503 8.77329 9.69832 8.77329C9.86161 8.77329 10.0182 8.83816 10.1337 8.95362C10.2491 9.06908 10.314 9.22569 10.314 9.38898ZM10.314 6.92623C10.314 7.08952 10.2491 7.24612 10.1337 7.36159C10.0182 7.47705 9.86161 7.54192 9.69832 7.54192C9.53503 7.54192 9.37843 7.47705 9.26297 7.36159C9.1475 7.24612 9.08264 7.08952 9.08264 6.92623C9.08264 6.76294 9.1475 6.60634 9.26297 6.49088C9.37843 6.37541 9.53503 6.31055 9.69832 6.31055C9.86161 6.31055 10.0182 6.37541 10.1337 6.49088C10.2491 6.60634 10.314 6.76294 10.314 6.92623ZM7.23558 9.38898C7.23558 9.55227 7.17071 9.70887 7.05525 9.82433C6.93979 9.93979 6.78319 10.0047 6.61989 10.0047C6.45661 10.0047 6.3 9.93979 6.18454 9.82433C6.06908 9.70887 6.00421 9.55227 6.00421 9.38898C6.00421 9.22569 6.06908 9.06908 6.18454 8.95362C6.3 8.83816 6.45661 8.77329 6.61989 8.77329C6.78319 8.77329 6.93979 8.83816 7.05525 8.95362C7.17071 9.06908 7.23558 9.22569 7.23558 9.38898ZM7.23558 6.92623C7.23558 7.08952 7.17071 7.24612 7.05525 7.36159C6.93979 7.47705 6.78319 7.54192 6.61989 7.54192C6.45661 7.54192 6.3 7.47705 6.18454 7.36159C6.06908 7.24612 6.00421 7.08952 6.00421 6.92623C6.00421 6.76294 6.06908 6.60634 6.18454 6.49088C6.3 6.37541 6.45661 6.31055 6.61989 6.31055C6.78319 6.31055 6.93979 6.37541 7.05525 6.49088C7.17071 6.60634 7.23558 6.76294 7.23558 6.92623ZM4.15715 9.38898C4.15715 9.55227 4.09229 9.70887 3.97682 9.82433C3.86136 9.93979 3.70476 10.0047 3.54147 10.0047C3.37818 10.0047 3.22157 9.93979 3.10611 9.82433C2.99065 9.70887 2.92578 9.55227 2.92578 9.38898C2.92578 9.22569 2.99065 9.06908 3.10611 8.95362C3.22157 8.83816 3.37818 8.77329 3.54147 8.77329C3.70476 8.77329 3.86136 8.83816 3.97682 8.95362C4.09229 9.06908 4.15715 9.22569 4.15715 9.38898ZM4.15715 6.92623C4.15715 7.08952 4.09229 7.24612 3.97682 7.36159C3.86136 7.47705 3.70476 7.54192 3.54147 7.54192C3.37818 7.54192 3.22157 7.47705 3.10611 7.36159C2.99065 7.24612 2.92578 7.08952 2.92578 6.92623C2.92578 6.76294 2.99065 6.60634 3.10611 6.49088C3.22157 6.37541 3.37818 6.31055 3.54147 6.31055C3.70476 6.31055 3.86136 6.37541 3.97682 6.49088C4.09229 6.60634 4.15715 6.76294 4.15715 6.92623Z" fill="#FF8402"/>
                                    </svg>

                                </div>

                             {startDateFlag &&
                                <div className='addprfStrtCld' ref={stratDateRef}>
                                <Calendar value={moment(projectStartDate).toDate()} inline onChange={(e) => {
                                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                    setProjectStartDate(formattedDate);
                                    if (moment(formattedDate).isAfter(projectEndDate)) {
                                        setProjectEndDate(formattedDate);
                                    }
                                    if (project.projectStartDate.toString() !== formattedDate.toString()) { 
                                        setProjectUpdatePara(prevState => ({
                                            ...prevState,
                                            projectStartDate: formattedDate
                                        }));
                                    } else {
                                        setProjectUpdatePara(prevState => {
                                            const newState = { ...prevState };
                                            delete newState.projectStartDate;
                                            return newState;
                                        });
                                    }
                                    setStartDateFlag(false)
                                }} unstyled={false} />
                                </div>
                                }
                            </div>
                            {error && !prjStartDate ? <p style={{fontSize: '12px', color: 'red'}}>Please Select Project Start Date</p> : null}
                        </div>

                        <div className='slot-part-add-project'>
                            <label>*End Date</label>
                            {/* <input type='date' value={projectObj.projectStartDate} onChange={handleStartDate}></input> */}
                            <div className='prjStrDateHold'>

                                <div className='prjSatrtDate' onClick={() => {setEndDateFlag(true)}}>
                                    <p className='prjStrDtePara'>{projectEndDate}</p>

                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74656 1.93343C2.12713 2.01674 1.77036 2.17297 1.51 2.43355C1.24942 2.69391 1.09292 3.05096 1.00961 3.67038C0.92451 4.30309 0.923529 5.13714 0.923529 6.31108V7.54245C0.923529 8.71638 0.92451 9.55044 1.00961 10.1831C1.09292 10.8026 1.24914 11.1593 1.50973 11.4197C1.77009 11.6803 2.12713 11.8368 2.74656 11.9201C3.37926 12.0052 4.21332 12.0062 5.38725 12.0062H7.84999C9.02393 12.0062 9.85798 12.0052 10.4907 11.9201C11.1101 11.8368 11.4669 11.6806 11.7272 11.42C11.9878 11.1596 12.1443 10.8026 12.2276 10.1831C12.3127 9.55044 12.3137 8.71638 12.3137 7.54245V6.31108C12.3137 5.13714 12.3127 4.30309 12.2276 3.67038C12.1443 3.05096 11.9881 2.69419 11.7275 2.43383C11.4672 2.17325 11.1101 2.01674 10.4907 1.93343C9.85798 1.84834 9.02393 1.84736 7.84999 1.84736H5.38725C4.21332 1.84736 3.37926 1.84834 2.74656 1.93343ZM5.3525 0.923828H7.88474C9.01614 0.923819 9.91238 0.923811 10.6138 1.01815C11.3355 1.11521 11.9197 1.31972 12.3803 1.78052C12.8413 2.24113 13.0458 2.82544 13.1429 3.54728C13.2373 4.24868 13.2372 5.14492 13.2372 6.27632V7.57721C13.2372 8.7086 13.2373 9.60484 13.1429 10.3062C13.0458 11.028 12.8413 11.6123 12.3804 12.0729C11.9198 12.5338 11.3356 12.7383 10.6138 12.8354C9.91238 12.9297 9.01614 12.9297 7.88475 12.9297H5.35249C4.2211 12.9297 3.32486 12.9297 2.62345 12.8354C1.90161 12.7383 1.3173 12.5337 0.856692 12.0727C0.395887 11.6122 0.191385 11.0279 0.094319 10.3062C-1.73397e-05 9.60484 -9.56362e-06 8.7086 1.97977e-07 7.57719V6.27633C-9.56362e-06 5.14493 -1.73397e-05 4.24869 0.094319 3.54728C0.191395 2.82551 0.395928 2.24125 0.856831 1.78066C1.31742 1.31976 1.90168 1.11522 2.62345 1.01815C3.32486 0.923811 4.2211 0.923819 5.3525 0.923828Z" fill="#263238"/>
                                        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M3.54094 0C3.79597 0 4.00271 0.206739 4.00271 0.461764V1.38529C4.00271 1.64032 3.79597 1.84706 3.54094 1.84706C3.28592 1.84706 3.07918 1.64032 3.07918 1.38529V0.461764C3.07918 0.206739 3.28592 0 3.54094 0ZM9.6978 0C9.95282 0 10.1596 0.206739 10.1596 0.461764V1.38529C10.1596 1.64032 9.95282 1.84706 9.6978 1.84706C9.44277 1.84706 9.23603 1.64032 9.23603 1.38529V0.461764C9.23603 0.206739 9.44277 0 9.6978 0ZM0.308594 4.46372C0.308594 4.20869 0.515333 4.00196 0.770358 4.00196H12.4684C12.7234 4.00196 12.9301 4.20869 12.9301 4.46372C12.9301 4.71875 12.7234 4.92548 12.4684 4.92548H0.770358C0.515333 4.92548 0.308594 4.71875 0.308594 4.46372Z" fill="#263238"/>
                                        <path d="M10.314 9.38898C10.314 9.55227 10.2491 9.70887 10.1337 9.82433C10.0182 9.93979 9.86161 10.0047 9.69832 10.0047C9.53503 10.0047 9.37843 9.93979 9.26297 9.82433C9.1475 9.70887 9.08264 9.55227 9.08264 9.38898C9.08264 9.22569 9.1475 9.06908 9.26297 8.95362C9.37843 8.83816 9.53503 8.77329 9.69832 8.77329C9.86161 8.77329 10.0182 8.83816 10.1337 8.95362C10.2491 9.06908 10.314 9.22569 10.314 9.38898ZM10.314 6.92623C10.314 7.08952 10.2491 7.24612 10.1337 7.36159C10.0182 7.47705 9.86161 7.54192 9.69832 7.54192C9.53503 7.54192 9.37843 7.47705 9.26297 7.36159C9.1475 7.24612 9.08264 7.08952 9.08264 6.92623C9.08264 6.76294 9.1475 6.60634 9.26297 6.49088C9.37843 6.37541 9.53503 6.31055 9.69832 6.31055C9.86161 6.31055 10.0182 6.37541 10.1337 6.49088C10.2491 6.60634 10.314 6.76294 10.314 6.92623ZM7.23558 9.38898C7.23558 9.55227 7.17071 9.70887 7.05525 9.82433C6.93979 9.93979 6.78319 10.0047 6.61989 10.0047C6.45661 10.0047 6.3 9.93979 6.18454 9.82433C6.06908 9.70887 6.00421 9.55227 6.00421 9.38898C6.00421 9.22569 6.06908 9.06908 6.18454 8.95362C6.3 8.83816 6.45661 8.77329 6.61989 8.77329C6.78319 8.77329 6.93979 8.83816 7.05525 8.95362C7.17071 9.06908 7.23558 9.22569 7.23558 9.38898ZM7.23558 6.92623C7.23558 7.08952 7.17071 7.24612 7.05525 7.36159C6.93979 7.47705 6.78319 7.54192 6.61989 7.54192C6.45661 7.54192 6.3 7.47705 6.18454 7.36159C6.06908 7.24612 6.00421 7.08952 6.00421 6.92623C6.00421 6.76294 6.06908 6.60634 6.18454 6.49088C6.3 6.37541 6.45661 6.31055 6.61989 6.31055C6.78319 6.31055 6.93979 6.37541 7.05525 6.49088C7.17071 6.60634 7.23558 6.76294 7.23558 6.92623ZM4.15715 9.38898C4.15715 9.55227 4.09229 9.70887 3.97682 9.82433C3.86136 9.93979 3.70476 10.0047 3.54147 10.0047C3.37818 10.0047 3.22157 9.93979 3.10611 9.82433C2.99065 9.70887 2.92578 9.55227 2.92578 9.38898C2.92578 9.22569 2.99065 9.06908 3.10611 8.95362C3.22157 8.83816 3.37818 8.77329 3.54147 8.77329C3.70476 8.77329 3.86136 8.83816 3.97682 8.95362C4.09229 9.06908 4.15715 9.22569 4.15715 9.38898ZM4.15715 6.92623C4.15715 7.08952 4.09229 7.24612 3.97682 7.36159C3.86136 7.47705 3.70476 7.54192 3.54147 7.54192C3.37818 7.54192 3.22157 7.47705 3.10611 7.36159C2.99065 7.24612 2.92578 7.08952 2.92578 6.92623C2.92578 6.76294 2.99065 6.60634 3.10611 6.49088C3.22157 6.37541 3.37818 6.31055 3.54147 6.31055C3.70476 6.31055 3.86136 6.37541 3.97682 6.49088C4.09229 6.60634 4.15715 6.76294 4.15715 6.92623Z" fill="#FF8402"/>
                                    </svg>

                                </div>

                             {endDateFlag &&
                                <div className='addprfEndCld' ref={endDateRef}>
                                <Calendar value={moment(projectEndDate).toDate()} inline onChange={(e) => {
                                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                    setProjectEndDate(formattedDate)          
                                    if (project.projectEndDate.toString() !== formattedDate.toString()) { 
                                        setProjectUpdatePara(prevState => ({
                                            ...prevState,
                                            projectEndDate: formattedDate
                                        }));
                                    } else {
                                        setProjectUpdatePara(prevState => {
                                            const newState = { ...prevState };
                                            delete newState.projectEndDate;
                                            return newState;
                                        });
                                    }
                                    setEndDateFlag(false)
                                }} unstyled={false} minDate={new Date(projectStartDate)} />
                                </div>
                                }
                            </div>
                            {error && !projectEndDate ? <p style={{fontSize: '12px', color: 'red'}}>Please Select Project Start Date</p> : null}
                        </div>

                    </div>
                    <div className='project-info-slot1  project-info-Deprtment'>
                        <label>*Department</label>
                        {/* <Select options={departmentList} placeholder="Select Department" value={departmentName} onChange={handleDepartment} isSearchable={true} isMulti={true} className='projectForm-select' /> */}
                        <div className='departmentHolder' onClick={() => {setDeprtListFlag(true)}}>
                            <div className='deaprtMultipleHolder' >
                                { projectDepartments && projectDepartments.length > 0 && projectDepartments.map((deprtObj) => (
                                    <div className='deprtContHolder' style={{backgroundColor: deprtObj ? deprtObj.departmentColorCode : null }}>
                                        <p>{deprtObj.departmentName}</p>
                                        <svg style={{height: '10px', width: '10px'}} width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                            const updatedList = projectDepartments.filter(obj => obj !== deprtObj);
                                            setProjectDepartments(updatedList);
                                        }}>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.897382 4.49752C0.726915 4.32706 0.726914 4.0507 0.897382 3.88025L2.44048 2.33729L0.897382 0.794327C0.726914 0.623874 0.726915 0.347516 0.897382 0.177063C1.06785 0.00661067 1.34423 0.00661043 1.5147 0.177063L3.05779 1.72003L4.60129 0.176667C4.77175 0.00621482 5.04814 0.00621507 5.2186 0.176668C5.38907 0.347121 5.38907 0.623479 5.2186 0.793931L3.67511 2.33729L5.2186 3.88065C5.38907 4.0511 5.38907 4.32746 5.2186 4.49791C5.04814 4.66836 4.77175 4.66836 4.60129 4.49791L3.05779 2.95455L1.5147 4.49752C1.34423 4.66797 1.06785 4.66797 0.897382 4.49752Z" fill="#263238" fill-opacity="0.6"/>
                                        </svg>
                                    </div>
                                    ))
                                }
                            </div>

                            { deprtListFlag && 
                                <div className='deprtListHolder' ref={deprtListRef}>
                                    <div className='deprtListScroller'>
                                        { departmentList && departmentList.length > 0 && departmentList.map((deprtObj) => (
                                            <div className='deprtContHolder' style={{backgroundColor: deprtObj ? deprtObj.departmentColorCode : null }} onClick={() => {
                                                const isTagAlreadySelected = projectDepartments.some(item => item.departmentId === deprtObj.departmentId);
                                                if (!isTagAlreadySelected || projectDepartments.length === 0) {
                                                  setProjectDepartments([...projectDepartments, deprtObj]);                                                  
                                                }
                                            }}>
                                                <p>{deprtObj.departmentName}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>
                        {error && (!projectDepartments || projectDepartments.length === 0) ? <p style={{fontSize: '12px', color: 'red'}}>Please select departments</p> : null}
                    </div>
                    <div className='project-assignto-info'>
                        <label>Assign to</label>
                        {/* <Select options={assigneeList} placeholder="Select Assign to..." value={assignee} onChange={handleAssignTo} isSearchable={true} isMulti={true} className='projectForm-select' /> */}
                        <div className='assigneeHolder' onClick={() => {
                            setAssigneeListFalg(true)}}>
                            <div className='assigneeMultipleHolder'>
                                { projectEmployees && projectEmployees.length > 0 && projectEmployees.map((assigneeObj) => (
                                    <div className='assignneDld'>
                                        <div className='imgHoldDiv'>
                                            <img style={{height: '25px', width: '25px', borderRadius: '50px'}} src={assigneeObj.empImg !== null  ?  assigneeObj.empImg : profile}  alt=''/>
                                        </div>
                                        <p style={{width: 'max-content'}}>{assigneeObj.empFullName}</p>
                                        <svg style={{height: '13px',width: '13px'}} width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.818439 5.18117C0.643854 5.0066 0.643853 4.72356 0.818439 4.54899L2.39882 2.96875L0.818439 1.38851C0.643853 1.21394 0.643854 0.930904 0.818439 0.756333C0.993025 0.581763 1.27609 0.581762 1.45067 0.756333L3.03105 2.33657L4.61183 0.755928C4.78642 0.581357 5.06947 0.581357 5.24406 0.755928C5.41865 0.930499 5.41865 1.21353 5.24406 1.3881L3.66328 2.96875L5.24406 4.5494C5.41865 4.72397 5.41865 5.007 5.24406 5.18157C5.06947 5.35614 4.78642 5.35614 4.61183 5.18157L3.03105 3.60093L1.45067 5.18117C1.27609 5.35574 0.993025 5.35574 0.818439 5.18117Z" fill="#263238" fill-opacity="0.6"/>
                                        </svg>
                                    </div>  
                                ))}
                            </div>

                            { assigneeListFalg && 
                                <div className='assigneeListHold' ref={assigneeListRef}> 
                                    <div className='selectedListAssHold'>
                                        {projectEmployees && projectEmployees.length > 0 &&  projectEmployees.map((assigneeObj) => (
                                                <div className='assigneeHld'>
                                                    <div className='imgHoldDiv'>
                                                        <img style={{height: '25px', width: '25px', borderRadius: '50px'}} src={assigneeObj.empImg !== null ? assigneeObj.empImg : profile}  alt=''/>
                                                    </div>
                                                    <p style={{width: 'max-content'}}>{assigneeObj.empFullName}</p>
                                                    <svg style={{height: '13px', width: '13px', cursor: 'pointer'}} width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                                        const updatedList = projectEmployees?.filter(obj => obj !== assigneeObj);
                                                        setProjectEmployees(updatedList)
                                                        assigneeList?.push(assigneeObj)
                                                        setAssigneeList(assigneeList)
                                                    }}>
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.818439 5.18117C0.643854 5.0066 0.643853 4.72356 0.818439 4.54899L2.39882 2.96875L0.818439 1.38851C0.643853 1.21394 0.643854 0.930904 0.818439 0.756333C0.993025 0.581763 1.27609 0.581762 1.45067 0.756333L3.03105 2.33657L4.61183 0.755928C4.78642 0.581357 5.06947 0.581357 5.24406 0.755928C5.41865 0.930499 5.41865 1.21353 5.24406 1.3881L3.66328 2.96875L5.24406 4.5494C5.41865 4.72397 5.41865 5.007 5.24406 5.18157C5.06947 5.35614 4.78642 5.35614 4.61183 5.18157L3.03105 3.60093L1.45067 5.18117C1.27609 5.35574 0.993025 5.35574 0.818439 5.18117Z" fill="#263238" fill-opacity="0.6"/>
                                                    </svg>
                                                </div>  
                                            ))}
                                    </div>

                                    <div className='assnListScrollerDiv'>
                                        <div className='assnListScroller'>
                                            { assigneeList && assigneeList.length > 0 && assigneeList.map((assigneeObj) => (
                                                <div className='assignneDld' onClick={() => {
                                                    const isTagAlreadySelected = projectEmployees.some(item => item.empId === assigneeObj.empId);
                                                
                                                    if (!isTagAlreadySelected || projectEmployees.length === 0) {
                                                    setProjectEmployees([...projectEmployees, assigneeObj]);
                                                    setAssigneeList(assigneeList?.filter(obj => obj?.empId !== assigneeObj?.empId))
                                                    }
                                                }}>
                                                    <div className='imgHoldDiv'>
                                                        <img style={{height: '25px', width: '25px', borderRadius: '50px'}} src={assigneeObj.empImg !== null ? assigneeObj.empImg : profile}  alt=""/>
                                                    </div>
                                                    <p>{assigneeObj.empFullName}</p>
                                                </div>
                                            ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {error && (!selectedAssigneeList || selectedAssigneeList.length === 0) ? <p style={{fontSize: '12px', color: 'red'}}>Please select Employees</p> : null}
                    </div>
                    {/* <div className='project-info-slot2'>
                        <div className='slot-part-add-project'>
                            <label>status</label>
                            <Select options={statusList} placeholder="Select Status" value={status} isSearchable={true} onChange={handleStatusChange} isMulti={false} className='projectForm-select' />
                        </div>
                    </div> */}
                    <div className='project-sel-priority'>
                        <div className='slot-part-add-project'>
                            <label>*Priority</label>
                            {/* <Select options={priorityList} placeholder="Select Role" value={priority} isSearchable={true} onChange={handlePriorityChange} isMulti={false} className='projectForm-select' /> */}
                            <div className='selcted-pr-prj' onClick={() => {setPriorityListFlag(true)}}>
                                <div style={{backgroundColor: projectPriority ? projectPriority.priorityColorCode : null }} className='selProirityForPrj'>
                                    {projectPriority?.priority}
                                </div>
                            </div>

                            { priorityListFlag && 
                                <div className='priorityListCtn' ref={priorityListRef}>
                                    { priorityList && priorityList.length > 0 && priorityList.map((priorityObj) => (
                                        <div style={{backgroundColor: priorityObj ? priorityObj.priorityColorCode : null }} className='selProirityForPrj' onClick={() => {
                                                var tempProjectPriority = priorityObj  
                                                setProjectPriority(priorityObj)
                                                if(project.projectPriority.priorityId.toString() !== tempProjectPriority.priorityId.toString()){
                                                    setProjectUpdatePara(prevState => ({
                                                    ...prevState,
                                                    ['projectPriority']: tempProjectPriority.priorityId
                                                }));
                                                projectUpdatePara['projectPriority'] = tempProjectPriority.priorityId
                                                setProjectUpdatePara(projectUpdatePara)
                                                }else{
                                                delete projectUpdatePara['projectPriority']
                                                setProjectUpdatePara(projectUpdatePara)
                                                }
                                            setPriorityListFlag(false)
                                            }}>
                                            {priorityObj.priority}
                                        </div>
                                    ))}
                                </div>
                            }
                            {error && !selectedPriority ? <p style={{fontSize: '12px', color: 'red'}}>Please select Priority</p> : null}
                        </div>
                    </div>
                </div>
                <div className='form-bottom-buttons'>
                    <div className='AddEmpButtonEmpty' onClick={handleSubmit}>Save</div>
                    <div className='cancelBtn' onClick={() =>
                        dispatch(setUpdateProjectFlag(false))
                    }>Cancel</div>
                </div>
            </div>
        </div>
  )
}

export default UpdateProject
